import { defineEvent, type EventPayload } from '@nexus/core';
import { z } from 'zod';

// Events carry IDs, never personal data: subscribers load what they need through the public API
// (docs/architecture/base-modules.md, Verweise auf Datensätze).

export const organizationCreated = defineEvent(
  'crm.organization.created',
  z.object({ id: z.uuid() }),
);
export type OrganizationCreated = EventPayload<typeof organizationCreated>;

export const organizationUpdated = defineEvent(
  'crm.organization.updated',
  z.object({ id: z.uuid() }),
);
export type OrganizationUpdated = EventPayload<typeof organizationUpdated>;

/** Archived or taken back from the archive; references stay, the UI marks them. */
export const organizationArchived = defineEvent(
  'crm.organization.archived',
  z.object({ id: z.uuid(), archived: z.boolean() }),
);
export type OrganizationArchived = EventPayload<typeof organizationArchived>;

/** `id` was merged into `intoId`: move references from `id` to `intoId`. */
export const organizationMerged = defineEvent(
  'crm.organization.merged',
  z.object({ id: z.uuid(), intoId: z.uuid() }),
);
export type OrganizationMerged = EventPayload<typeof organizationMerged>;

export const contactCreated = defineEvent('crm.contact.created', z.object({ id: z.uuid() }));
export type ContactCreated = EventPayload<typeof contactCreated>;

/** Changed, left the organisation, became or stopped being the main contact, or moved by a merge. */
export const contactUpdated = defineEvent('crm.contact.updated', z.object({ id: z.uuid() }));
export type ContactUpdated = EventPayload<typeof contactUpdated>;

/** Deleted by hand: name and contact details are gone, references show "not available". */
export const contactDeleted = defineEvent('crm.contact.deleted', z.object({ id: z.uuid() }));
export type ContactDeleted = EventPayload<typeof contactDeleted>;
